import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SearchBar = ({ onSearch, suggestions }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setShowSuggestions(searchTerm.length > 0);
  }, [searchTerm]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearch(value);
  };

  const handleSuggestionClick = (suggestion) => {
    setSearchTerm(suggestion.title);
    onSearch(suggestion.title);
    setShowSuggestions(false);
    navigate(`/network/${suggestion.networkName.toLowerCase().replace(/\s+/g, '-')}`, {
      state: { highlightedSyntaxId: suggestion.id }
    });
  };

  return (
    <div className="w-full max-w-2xl mx-auto relative">
      <input
        type="text"
        placeholder="Rechercher une syntaxe..."
        className="w-full px-4 py-2 text-lg border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
        value={searchTerm}
        onChange={handleSearch}
      />
      {showSuggestions && (
        <ul className="absolute w-full bg-white border border-gray-300 mt-1 rounded-lg shadow-lg z-10">
          {suggestions.length > 0 ? (
            suggestions.map((suggestion, index) => (
              <li 
                key={index} 
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => handleSuggestionClick(suggestion)}
              >
                {suggestion.title} - {suggestion.networkName}
              </li>
            ))
          ) : (
            <li className="px-4 py-2 text-gray-500">Aucune correspondance trouvée.</li>
          )}
        </ul>
      )}
    </div>
  );
};

export default SearchBar;